import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Rating,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

type Props = {
  lifes: number;
  questionIndex: number;
  maxLives?: number;
  showHeart: boolean;
  showUsedHeart: boolean;
};

export const ChallengeLifes = ({
  lifes,
  questionIndex,
  maxLives,
  showHeart,
  showUsedHeart,
}: Props) => {
  const theme = useTheme();
  const xsBreakpoint = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <>
      <Stack alignItems={'center'} spacing={1}>
        <Box height={50}>
          {showHeart && questionIndex > 0 && (
            <div className="heart-animation">
              <Stack
                direction={'row'}
                spacing={2}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Typography>+1</Typography>
                <FavoriteIcon
                  style={{
                    color: '#ff6d75',
                  }}
                />
                <Typography>You gained a life!</Typography>
              </Stack>
            </div>
          )}
          {showUsedHeart && (
            <div className="float-fade">
              <Stack
                direction={'row'}
                spacing={2}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Typography>-1</Typography>
                <FavoriteIcon
                  style={{
                    color: 'lightgray',
                  }}
                />
                <Typography>You lost a life!</Typography>
              </Stack>
            </div>
          )}
        </Box>
        <Rating
          name="customized-color"
          readOnly
          size={xsBreakpoint ? 'small' : 'large'}
          defaultValue={0}
          max={maxLives ? maxLives : xsBreakpoint ? 5 : 10}
          value={lifes}
          getLabelText={(value: number) =>
            `${value} Heart${value !== 1 ? 's' : ''}`
          }
          precision={1}
          icon={<FavoriteIcon fontSize="inherit" />}
          emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
          sx={{
            '& .MuiRating-iconFilled': {
              color: '#ff6d75',
            },
          }}
        />
        {lifes > (xsBreakpoint ? 5 : 10) ? (
          <Avatar
            sx={{
              backgroundColor: '#ff6d75',
              color: '#3b191b',
              width: xsBreakpoint ? 24 : 40,
              height: xsBreakpoint ? 24 : 40,
              fontSize: xsBreakpoint ? '16px' : '20px',
            }}
          >
            +{lifes - (xsBreakpoint ? 5 : 10)}
          </Avatar>
        ) : null}
      </Stack>
      <div>
        {/* {showHeart && (
          <div className="heart-animation">
            <Stack alignItems={'center'} justifyContent={'center'}>
              <Typography>STAGE {stage}</Typography>
              <FavoriteIcon style={{ fontSize: '50px', color: '#ff6d75' }} />
              <Typography>You gained a life!</Typography>
            </Stack>
          </div>
        )} */}
        {/* {showUsedHeart && (
          <div className="heart-animation">
            <Stack alignItems={'center'} justifyContent={'center'}>
              <FavoriteIcon
                style={{
                  fontSize: '50px',
                  color: 'lightgray',
                }}
              />
              <Typography>You lost a life!</Typography>
            </Stack>
          </div>
        )} */}
      </div>
    </>
  );
};
